
export default function initImgTabs() {
    const allImgTabs = document.querySelectorAll("[data-img-tabs]")
    
    if (allImgTabs) {
        allImgTabs.forEach((tabs) => {
            const arr = Array.from(tabs.children)
            const tabImgPages = document.querySelectorAll(`.${tabs.getAttribute("data-img-tabs")} > *`)
            arr.forEach((elem) => {
                elem.addEventListener("mouseover", () => {
                    arr.forEach((e) => e.classList.remove("tab-active"))
                    tabImgPages.forEach((item) => item.classList.remove("tab-active"))

                    elem.classList.add("tab-active")
                    try {
                        tabImgPages[elem.getAttribute("data-tab-img-page")].classList.add("tab-active")
                    } catch (e) {
                        console.error(e)
                    }
                })
				elem.addEventListener("mouseout", () => {
					tabImgPages.forEach((item) => item.classList.remove("tab-active"))
					elem.classList.remove("tab-active")
				})
            })
        })
    }
}
